<script setup>
import {ref, onMounted} from "vue";
import {userLogin} from "@/api/login/login.js"
import {adminLoginHooks, userLoginHooks} from "@/hooks/user.js";
import {getRoute} from "@/hooks/getRoute.js";

const {route} = getRoute()

const title = ref(import.meta.env.VITE_API_TITLE)
onMounted(() => {
  // 开发环境自动填写超级管理员账号密码
  const isDev = import.meta.env.VITE_APP_ENV !== 'production' && import.meta.env.VITE_APP_ENV !== 'qime'
  if (isDev) {
    name.value = "admin"
    password.value = "123456"
  }
})
// 表单信息
const form = ref()
const name = ref()
const nameRules = ref([
  v => !!v || '请输入用户名',
])
const password = ref()
const passwordRules = ref([
  v => !!v || '请输入密码',
])
const loading = ref(false)
// 处理登录
async function submit() {
  try {
    const {valid} = await form.value.validate()
    if (valid) {
      const param = ref({
        username: name,
        password: password
      })
      const res = await userLogin(param.value)
      await adminLoginHooks(res)
    }
  } catch (err) {
    showTips.value = true
    errMsg.value = err
    console.log("不通过:", err)
  }
}
// 临时使用，1：微信登录 2：账号密码登录
const loginType = ref(2)
const showTips = ref(false)
const errMsg = ref('用户名或密码错误')

// ICP备案
const icpBeiAn = ref(import.meta.env.VITE_ICP)
// 公安备案
const gongAnBeiAn = ref(import.meta.env.VITE_GON)
</script>

<template>
  <div class="lg_bg">
<!--    <div class="lg_bg_mask"></div>-->
    <v-card
        class="mx-auto my-8"
        elevation="16"
        width="400"
        :height="loginType === 1 ? '250' : '350'"
    >
      <v-card-item>
        <v-card-title class="txt_center">
          <span class="lg_title font-weight-black">
            {{title}}商家管理系统
          </span>
        </v-card-title>
      </v-card-item>

      <v-card-text>
        <v-form class="pd_t_3" ref="form" validate-on="submit lazy" @submit.prevent="submit">
          <div>
            <v-text-field
                v-model="name"
                :counter="11"
                maxlength="11"
                :rules="nameRules"
                label="用户名："
                variant="underlined"
                clearable
                required
            ></v-text-field>
            <v-text-field
                v-model="password"
                :counter="16"
                maxlength="16"
                :rules="passwordRules"
                label="密码："
                type="password"
                variant="underlined"
                clearable
                required
            ></v-text-field>
            <!-- 临时使用 -->
            <div style="width: 100%;height: 20px" class="tips_err mg_b_1">
              <transition name="el-zoom-in-top">
                <span v-if="showTips">{{errMsg}}</span>
              </transition>
            </div>
            <v-btn
                :loading="loading"
                class="mt-2"
                text="登录"
                type="submit"
                block
                color="primary"
            ></v-btn>
          </div>
        </v-form>
      </v-card-text>
      <div class="beian_box">
        <div style="max-height: 21px">
          <el-link target="_blank" style="color: #eeeeee;margin-right: 10px" type="default" href="https://beian.miit.gov.cn/#/Integrated/index" :underline="false">粤ICP备{{icpBeiAn}}号</el-link>
        </div>
        <div style="max-height: 21px">
          <div class="beian_icon"></div>
          <el-link target="_blank" style="color: #eeeeee;margin-right: 10px" type="default" :href="`https://beian.mps.gov.cn/#/query/webSearch?recordcode=${icpBeiAn}}`" :underline="false">粤公网安备{{gongAnBeiAn}}号</el-link>
        </div>
      </div>
    </v-card>
  </div>
</template>

<style lang="scss" scoped>
.lg_bg {
  width: 100vw;
  height: 100vh;
  background: #1e1e1e;
  //background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: left;
  //.lg_bg_mask {
  //  position: absolute;
  //  top: 0;
  //  left: 0;
  //  width: 100vw;
  //  height: 100vh;
  //  background: rgba(30, 30, 30, .5);
  //}
  .lg_title {
    font-size: 30px;
  }
  .lg_tips {
    color: #999;
    font-size: 18px;
  }
}
.beian_box {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.beian_icon {
  width: 18px;
  height: 18px;
  display: inline-block;
  margin-right: 5px;
  background-image: url("@/assets/images/login/hz_icon.png");
  background-position: -40px 0;
  background-repeat: no-repeat;
  vertical-align: middle;
}
</style>
